// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Nrbs","inputWrap":"Table_inputWrap__358Qf","col":"Table_col__hBOZW","bmiTooltip":"Table_bmiTooltip__2YC2n"};